import React, { useEffect, useState } from 'react';
import { Typography, Container, Button, InputLabel, Grid, Paper, Toolbar, CircularProgress } from '@material-ui/core'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import MaterialTable from 'material-table';
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import { NotificationActions, BankPaymentActions } from '../../../store';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
    },

    infoTitle: {
        "& h1": {
            float: 'left'
        },
        "& div": {
            width: '100px',
            display: 'block',
            margin: '0 0 5px auto'
        }
    },
    amount: {
        fontSize: '14px',
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const bankPaymentSelector = (state) => state.BankPayment;
const IdentitySelector = (state) => state.Identity;

const BankSettlementByDate = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const bankPaymentActions = bindActionCreators(BankPaymentActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { listDaily, nowWainting } = useSelector(bankPaymentSelector);
    const { token } = useSelector(IdentitySelector);

    const { classes } = props;

    const listDefinition = {
        columns: [
            {
                // 日付
                title: <FormattedMessage id="Adjustment.Date" />,
                field: 'nengappi',
                filtering: false
            },
            {
                // 金額
                title: <FormattedMessage id="Adjustment.AmountOfMoney" />,
                field: 'bank_payment',
                type: 'currency',
                currencySetting: { currencyCode: 'JPY', minimumFractionDigits: 0, maximumFractionDigits: 0 },
                filtering: false
            },
        ]
    };

    /**
     *
     * 戻る押下時の処理
     *
     */
    const onBackClick = () => {
        props.onCancel();
    }

    const placeholder = <FormattedMessage id="Table.Action" />;

    // リストタイトル（検索期間）
    var listTitle = '';
    if (props.startDt != null && props.startDt != undefined && props.endDt != null && props.endDt != undefined) {
        const sdt = new Date(props.startDt);
        let startDt = sdt.getFullYear() + '/' + ("0" + (sdt.getMonth() + 1)).slice(-2) + '/' + ("0" + sdt.getDate()).slice(-2);
        const edt = new Date(props.endDt);
        let endDt = edt.getFullYear() + '/' + ("0" + (edt.getMonth() + 1)).slice(-2) + '/' + ("0" + edt.getDate()).slice(-2);
        listTitle = `[${startDt} - ${endDt}]`
    }
    
    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>
                <Toolbar variant="regular">
                    <div>
                        <Typography component="h1" variant="inherit">{<FormattedMessage id="Adjustment.BankSettlementByDate" />}</Typography>
                    </div>
                </Toolbar>
                <Grid container className={classes.form} spacing={2}>
                    <Grid item xs={2}>
                        <InputLabel component="legend"><FormattedMessage id={"Adjustment.Bank"} /></InputLabel>
                    </Grid>
                    <Grid item xs={10}>
                        <InputLabel component="legend">{props.bankName}</InputLabel>
                    </Grid>
                    <Grid item xs={2}>
                        <InputLabel component="legend"><FormattedMessage id={"Adjustment.PaymentAgent"} /></InputLabel>
                    </Grid>
                    <Grid item xs={10}>
                        <InputLabel component="legend">{props.agencyName}</InputLabel>
                    </Grid>
                    <Grid item xs={2}>
                        <InputLabel component="legend"><FormattedMessage id={"Adjustment.Type"} /></InputLabel>
                    </Grid>
                    <Grid item xs={10}>
                        <InputLabel component="legend">{props.kindName}</InputLabel>
                    </Grid>
                </Grid>
            </Paper>
            <MaterialTable
                title={<Typography component="h2" variant="inherit">{listTitle}</Typography>}
                columns={listDefinition.columns}
                data={listDaily}
                options={{
                    search: false,
                    actionsColumnIndex: -1,
                }}
                localization={{
                    body: {
                        emptyDataSourceMessage: <FormattedMessage id="Table.EmptyDataSourceMessage" />
                    },
                    header: {
                        actions: ''
                    },
                }}
                components={{
                    Action: actionProps => {
                        if (actionProps.action.tooltip !== "Add") {
                            return (
                                <div></div>
                            )
                        } else {
                            return (
                                <div></div>
                            )
                        }
                    },
                }}
                editable={{
                    onRowAdd: newData => { },
                    onRowUpdate: (newData, oldData) => { }
                }}
            />

            <div style={{ padding: 10 }}>
                <Grid container item xs={12} spacing={2} justify="center">
                    <Grid item xs={3} sm={6}>
                        <Button fullWidth variant="contained" size="medium"
                            startIcon={<ArrowBackIosIcon />}
                            onClick={onBackClick}><FormattedMessage id="Button.Back" /></Button>
                    </Grid>
                </Grid>
            </div>

            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(BankSettlementByDate);
